import { createFileRoute } from '@tanstack/react-router';

export const Route = createFileRoute('/user/appearance')({
	component: UserAppearancePage,
});

function UserAppearancePage() {
	return <div></div>;
}
